import { render, staticRenderFns } from "./TechTalk.vue?vue&type=template&id=8242343c&scoped=true&"
import script from "./TechTalk.vue?vue&type=script&lang=js&"
export * from "./TechTalk.vue?vue&type=script&lang=js&"
import style0 from "./TechTalk.vue?vue&type=style&index=0&id=8242343c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8242343c",
  null
  
)

export default component.exports